var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1199 1.74144C10.7977 1.41952 10.2754 1.41952 9.95333 1.74144C9.63113 2.06336 9.63113 2.58525 9.95333 2.90715L11.8428 4.78687H2.32154C1.86786 4.78687 1.50002 5.15443 1.50002 5.60768C1.50002 6.06107 1.86786 6.42864 2.32154 6.42864H13.8227C14.1544 6.42699 14.4525 6.22621 14.5785 5.91969C14.7072 5.614 14.6391 5.26099 14.406 5.02488L11.1199 1.74144ZM13.8212 8.07146H2.32009C1.98841 8.07311 1.69026 8.27389 1.5643 8.58027C1.43559 8.88596 1.50365 9.23883 1.73674 9.4748L5.02282 12.7573C5.17711 12.9127 5.38711 13 5.60615 13C5.82519 13 6.03508 12.9127 6.18934 12.7573C6.34487 12.6033 6.43233 12.3934 6.43233 12.1746C6.43233 11.9558 6.34487 11.7461 6.18934 11.592L4.29987 9.71267H13.8211C14.2748 9.71267 14.6427 9.34535 14.6427 8.8921C14.6427 8.43885 14.2748 8.07143 13.8211 8.07143L13.8212 8.07146Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/Compare.7f8dc3582d0392d8841cc3f377018aca.svg";
export { ForwardRef as ReactComponent };